'use-client';
import * as React from 'react';
import type { ICustomElementComponentProps } from '../../../types';
import CustomElementComponent from '../../CustomElementComponent';

const CustomElement: React.FC<ICustomElementComponentProps> = props => {
  return <CustomElementComponent {...props} isEnabled={true} />;
};

export default CustomElement;
